"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _excluded = ["type", "className", "title", "children", "size"];
var Msg = function Msg(props) {
  var _classnames;
  var type = props.type,
    className = props.className,
    title = props.title,
    children = props.children,
    size = props.size,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var comCls = (0, _usePrefixCls.usePrefixCls)('msg');
  var classes = (0, _classnames2.default)(comCls, className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(comCls, "--").concat(type), !!type), (0, _defineProperty2.default)(_classnames, "size-".concat(size), !!size && size !== 'default'), _classnames));
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(comCls, "__body")
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(comCls, "__icon")
  }), title && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(comCls, "__title")
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(comCls, "__desc")
  }, children)));
};
Msg.defaultProps = {
  type: 'explain'
};
var _default = exports.default = Msg;